import "./Contact.css";
import Hero from "./hero/Hero";
import ContactUs from "./contact-us/ContactUs";
import ContactSEO from "../../components/SEO/ContactSEO";

const Contact = () => {
  return (
    <>
      <ContactSEO />
      <Hero />
      <ContactUs />
    </>
  );
};

export default Contact;
